import { render } from "./BooleanGroupField.vue?vue&type=template&id=72dee920"
import script from "./BooleanGroupField.vue?vue&type=script&lang=js"
export * from "./BooleanGroupField.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/harixx_test/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"BooleanGroupField.vue"]])

export default __exports__